import type { FaireAdCampaignEntity } from "../../entity_types/adCampaign";

// Kaari & Co. — New-customers campaign (adc_5zncu7ev6x). Real lifetime
// aggregates from ANALYTICS.ADS_SNAPSHOTS.MANAGER_METRICS_CAMPAIGN_PERIODS.
// Monthly series lives in realBrandData.ts. The budget is the platform's
// standing recommendation ($910, and this is the one campaign of the three new
// brands flagged eligible for an increase); none is reported.
export const campKcNew: FaireAdCampaignEntity = {
  token: "camp_kc_new",
  type: "adCampaign",
  advertiserProfileToken: "adv_kaari_co",
  segment: "NEW_MARKETPLACE",
  status: "RUNNING",
  monthlyBudgetDollars: 910,
  startedRunningAt: "2024-02-01",
  segmentMetrics: {
    numCustomersAcquired: 59,
    salesDollars: 18702,
    totalAdsSpendDollars: 5088,
    cpaDollars: 86,
    bestEstimateSalesDollars: 18702,
    bestEstimateRoas: 3.68,
  },
  performancePeriodTokens: [],
  meta: {
    source: "snowflake",
    importedAt: "2026-08-20T00:00:00.000Z",
    importedBy: "real-brand-data",
  },
};
